import React from "react";
import Box from "@mui/material/Box";
import { HashLink } from "react-router-hash-link";
import { useTranslation } from "react-i18next";
import CurrencyFormat from "react-currency-format";

const AdminReviewsPartials = (props) => {
  const { t, i18n } = useTranslation();
  const purchases = props.purchases;
  console.log("purchases", purchases);
  return (
    <div
      style={{ paddingBottom: "10px", marginLeft: "20px", marginRight: "20px" }}
    >
      <div>
        {props.purchases.map((order, idx) => (
          <Box key={idx}>
            <Box sx={{ fontSize: "14px" }}>
              <span>&bull;</span>{" "}
              <span className="pink_link">
                <HashLink
                  target="_blank"
                  to={"/admin/order_ko/" + order.id + "#top"}
                >
                  {order.id}
                </HashLink>
              </span>
              <span className="lightgray">{" / "}</span>
              <span className="">
                {order?.created &&
                  order?.created?.toDate().toLocaleDateString("fr-CA", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                  })}{" "}
                {order?.created &&
                  order?.created?.toDate().toLocaleTimeString("ko-KR")}
              </span>
              <span className="lightgray">{" / "}</span>
              <span style={{ color: "green" }}>
                {t(order.status[order.status.length - 1])}
              </span>
              <span className="lightgray">{" / "}</span>
              <CurrencyFormat
                decimalScale={2}
                value={order.finalPrice}
                displayType={"text"}
                thousandSeparator={true}
                suffix={"원"}
              />
            </Box>
          </Box>
        ))}
      </div>
    </div>
  );
};

export default AdminReviewsPartials;
